module.exports = {"id":"212150","name":"Max Meyer","rating":"79","photo":"./data/images/photos/2/212150.png","club":{"name":"FC Schalke 04","logo":"./data/images/clubs/FCSchalke04.png"},"positions":["MC","MOC","MDC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MaxMeyer0.json
// module id = 2934
// module chunks = 0